(function () {
  async function addProtector(root) {
    var form = root.querySelector('.obp-protector__buy-form');
    var buyButton = root.querySelector('[data-obp-protector-buy]');
    var errorWrapper = root.querySelector('.product-form__error-message-wrapper');
    var errorMessage = errorWrapper && errorWrapper.querySelector('.product-form__error-message');
    var variantId = Number(root.dataset.variantId);
    if (!form || !buyButton || !variantId || buyButton.disabled || buyButton.classList.contains('loading')) return;

    buyButton.classList.add('loading');
    buyButton.disabled = true;
    buyButton.setAttribute('aria-busy', 'true');
    if (errorWrapper) errorWrapper.hidden = true;

    try {
      var response = await fetch(window.theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      var result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Die Displayschutzfolie konnte nicht hinzugefügt werden.');

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: result.items?.[0] || result } }));
      window.setTimeout(function () { document.getElementById('Cart-Drawer')?.open(); }, 100);
    } catch (error) {
      if (errorWrapper && errorMessage) {
        errorMessage.textContent = error.message || 'Bitte versuchen Sie es erneut.';
        errorWrapper.hidden = false;
      }
    } finally {
      buyButton.classList.remove('loading');
      buyButton.disabled = false;
      buyButton.removeAttribute('aria-busy');
    }
  }

  function init(root) {
    if (!root || root.dataset.obpProtectorReady === 'true') return;
    root.dataset.obpProtectorReady = 'true';

    var form = root.querySelector('.obp-protector__buy-form');
    if (form) form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      addProtector(root);
    });

    var hero = root.querySelector('#bestellen');
    var sticky = root.querySelector('[data-obp-protector-sticky]');
    if (sticky && hero && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting && window.innerWidth <= 640;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        if (show) sticky.removeAttribute('inert');
        else sticky.setAttribute('inert', '');
      }, { threshold: 0.08 });
      observer.observe(hero);
    }
  }

  function initAll(container) {
    (container || document).querySelectorAll('[data-obp-protector]').forEach(init);
  }

  if (!window.__obpProtectorV2ControlsReady) {
    window.__obpProtectorV2ControlsReady = true;
    document.addEventListener('click', function (event) {
      var control = event.target.closest('[data-obp-protector-scroll], [data-obp-protector-sticky-submit]');
      if (!control) return;
      var root = control.closest('[data-obp-protector]');
      if (!root) return;
      if (control.matches('[data-obp-protector-scroll]')) root.querySelector('#bestellen')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (control.matches('[data-obp-protector-sticky-submit]')) addProtector(root);
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
